import { Grid, makeStyles, Typography } from "@material-ui/core";
import { ActionButtonsGroup } from "../buttonsGroup/ActionButtonsGroup";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    "& h2": {
      fontWeight: 400,
    },
  },
}));

export const SettingActions = () => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container justifyContent="space-between" alignItems="center">
      <Typography variant="h2">Settings</Typography>
      <ActionButtonsGroup hideIntegrateBtn />
    </Grid>
  );
};
